/** Preserve promoted campaign attribution and document fragments when entering the guide. */
export function retiredGiveawayTarget(search: string, hash: string): string {
  return `/page/izmir${search}${hash}`;
}
